import { render, staticRenderFns } from "./RewardsCode.vue?vue&type=template&id=233a9947&scoped=true"
import script from "./RewardsCode.vue?vue&type=script&lang=js"
export * from "./RewardsCode.vue?vue&type=script&lang=js"
import style0 from "./RewardsCode.vue?vue&type=style&index=0&id=233a9947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a9947",
  null
  
)

export default component.exports